module.exports = __webpack_public_path__ + "img/im_scrollfeature_03@2x.397e38d2.jpg";